import { render, staticRenderFns } from "./CorporatePodcastCreate.vue?vue&type=template&id=58bd16e9"
import script from "./CorporatePodcastCreate.vue?vue&type=script&lang=js"
export * from "./CorporatePodcastCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports